import moment from 'moment';
import _ from 'lodash';

import { CreateEditUsageEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

const INITIAL_STATE = {
  usageListData: [],
  usageListDataError: null,
  loading: false,
  printLoading: false,
  printError: null,
  fromDateMax: moment().add(1, 'month'),
  toDateMin: moment().subtract(1, 'month'),
  deleteLoadingError: null,
  deleteSuccessMsg: null,
  printData: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.USAGE_LIST: {
      return {
        ...state,
        usageListData: action.payload.map(item => ({
          ...item,
          [CreateEditUsageEnum.UsageDT]: item[CreateEditUsageEnum.UsageDT]
            ? moment(item[CreateEditUsageEnum.UsageDT]).format(
                DATE_FORMAT_FOR_UI
              )
            : '',
        })),
      };
    }

    case types.USAGE_CLEAR_GRID_DATA: {
      return {
        ...state,
        loading: false,
        usageListDataError: null,
      };
    }

    case types.USAGE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.PRINT_PREVIEW_ERROR:
      if (_.has(action.payload, 'data.Data.Message')) {
        const Errors = [
          {
            Title: TitleEnum.Error,
            Message: action.payload.data.Data.Message,
          },
        ];
        return {
          ...state,
          usageListDataError: Errors,
        };
      }
      return {
        ...state,
        usageListDataError: action.payload,
      };

    case types.PRINT_PREVIEW_USAGE_LOADING:
      return {
        ...state,
        printLoading: action.payload,
      };
    case types.SET_FROM_DATE_MAX:
      return {
        ...state,
        fromDateMax: action.payload,
      };
    case types.SET_TO_DATE_MIN:
      return {
        ...state,
        toDateMin: action.payload,
      };
    case types.USAGE_ERROR:
      return {
        ...state,
        deleteLoadingError: action.payload,
      };

    case types.CLEAR_USAGE_ERROR:
      return {
        ...state,
        deleteLoadingError: null,
        usageListDataError: null,
        deleteSuccessMsg: null,
      };
    case types.DELETE_SUCCESS_MESSAGE:
      return {
        ...state,
        deleteSuccessMsg: action.payload,
      };

    case types.SET_PRINT_DATA:
      return {
        ...state,
        printData: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/state/UsageList/reducer.js